<app-loading-app *ngIf="isLoading$ | async"></app-loading-app>
<app-page-view-tracker></app-page-view-tracker>

<router-outlet></router-outlet>

<simple-notifications></simple-notifications>
<app-feedback-button
	*ngIf="authService.isAuthenticated()"
></app-feedback-button>
